    // import { useNavigate } from 'react-router-dom';
    // import Footer from '../components/shared/Footer';


    // export default function Home() {
    // const navigate = useNavigate();

    // return (
    //     <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-8">
    //     <div className="max-w-3xl bg-white rounded shadow p-10 text-center">
    //         <h1 className="text-4xl font-bold mb-4 text-blue-700">Welcome to the Dentulu Developer Ecosystem</h1>
    //         <p className="text-gray-700 text-lg mb-6">
    //         Build, test, and manage your healthcare integrations on the most developer-friendly platform in dental tech.
    //         </p>
    //         <ul className="text-left text-gray-600 text-md mb-6 space-y-2 list-disc list-inside">
    //         <li>📦 Register and manage your third-party applications</li>
    //         <li>🔑 Generate API keys for staging and production</li>
    //         <li>📡 Subscribe to Dentulu event webhooks</li>
    //         <li>🧪 Simulate events and monitor delivery logs</li>
    //         <li>🤖 Coming soon: AI assistant to help with API usage</li>
    //         </ul>

    //         <div className="flex justify-center gap-4">
    //         <button
    //             onClick={() => navigate('/signup')}
    //             className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded"
    //         >
    //             Sign Up
    //         </button>
    //         <button
    //             onClick={() => navigate('/login')}
    //             className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded"
    //         >
    //             Login
    //         </button>
    //         </div>

    //         <p className="mt-4 text-sm text-gray-500">
    //         Forgot your password?{' '}
    //         <span
    //             className="text-blue-600 cursor-pointer hover:underline"
    //             onClick={() => navigate('/forgot-password')}
    //         >
    //             Reset it here
    //         </span>
    //         </p>
    //     </div>
    //     <Footer />
    //     </div>
    // );
    // }

    // Rename or update your current Home.jsx to be more explicitly a portal page:
// dev-portal/src/pages/Home.js
// dev-portal/src/pages/Home.js

import { Link, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Footer from '../components/shared/Footer';

    export default function Home() {
        const navigate = useNavigate();

        useEffect(() => {
            // If user is already logged in, redirect them
            const token = localStorage.getItem('token');
            const role = localStorage.getItem('role');
            
            if (token) {
            navigate(role === 'admin' ? '/admin' : '/dashboard');
            }
        }, [navigate]);

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
        <div className="flex-1 flex items-center justify-center p-8">
            <div className="bg-white shadow-lg rounded-lg p-8 max-w-4xl w-full">
            <div className="text-center mb-8">
                <Link to="/" className="text-blue-600 hover:underline mb-4 inline-block">
                ← Back to Marketplace
                </Link>
                <h1 className="text-4xl font-bold text-blue-600 mb-4">
                Dentulu Developer Ecosystem
                </h1>
                <p className="text-gray-600">
                Build powerful healthcare integrations with the most developer-friendly API platform in dental tech
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
                <div className="text-center">
                <div className="bg-blue-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-3xl">👨‍💻</span>
                </div>
                <h2 className="text-2xl font-semibold mb-3">For Developers</h2>
                <p className="text-gray-600 mb-6">
                    Build and integrate your applications with Dentulu's comprehensive API ecosystem
                </p>
                <Link 
                    to="/login" 
                    className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 inline-block"
                >
                    Developer Login
                </Link>
                </div>

                <div className="text-center">
                <div className="bg-red-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-3xl">🛡️</span>
                </div>
                <h2 className="text-2xl font-semibold mb-3">For Admins</h2>
                <p className="text-gray-600 mb-6">
                    Manage developers, approve applications, and monitor the ecosystem
                </p>
                <Link 
                    to="/admin-login" 
                    className="bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 inline-block"
                >
                    Admin Login
                </Link>
                </div>
            </div>

            {/* Platform Features */}
            <div className="mt-12 pt-8 border-t">
                <h3 className="text-xl font-semibold mb-6 text-center">Platform Features</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
                <div className="flex items-start gap-2">
                    <span className="text-green-600">✓</span>
                    <span className="text-gray-700">RESTful API with comprehensive documentation</span>
                </div>
                <div className="flex items-start gap-2">
                    <span className="text-green-600">✓</span>
                    <span className="text-gray-700">Webhook event subscriptions for real-time updates</span>
                </div>
                <div className="flex items-start gap-2">
                    <span className="text-green-600">✓</span>
                    <span className="text-gray-700">Staging and production API key management</span>
                </div>
                <div className="flex items-start gap-2">
                    <span className="text-green-600">✓</span>
                    <span className="text-gray-700">Comprehensive testing and simulation tools</span>
                </div>
                <div className="flex items-start gap-2">
                    <span className="text-green-600">✓</span>
                    <span className="text-gray-700">OAuth 2.0 authentication support</span>
                </div>
                <div className="flex items-start gap-2">
                    <span className="text-green-600">✓</span>
                    <span className="text-gray-700">Marketplace for showcasing your applications</span>
                </div>
                </div>
            </div>

            <div className="text-center mt-8 pt-8 border-t">
                <p className="text-gray-600 mb-4">New to the platform?</p>
                <Link 
                to="/signup" 
                className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 inline-block"
                >
                Sign Up as Developer
                </Link>
            </div>
            </div>
        </div>
        <Footer />
        </div>
    );
    }